import { motion } from "framer-motion";
import { Reveal, EASE } from "./motion";

const PILLARS = ["Clear recommendations", "Transparent pricing", "Personal service"];

export const Intro2 = () => (
  <section id="about" data-testid="about-intro-section" className="relative mx-auto max-w-[1440px] px-5 md:px-10 pt-24 md:pt-32">
    <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
      <Reveal className="lg:col-span-4"><p className="eyebrow">Our approach</p></Reveal>
      <div className="lg:col-span-8">
        <Reveal>
          <p className="font-display font-bold text-2xl md:text-4xl leading-[1.2] tracking-tight text-white" data-testid="about-intro-lead">
            We combine meticulous cleaning, careful preparation and finishes tailored to your vehicle's condition. From the crevices inside your cabin to the clarity of your paint, <span className="vel-text">our attention goes beyond what you see at first glance.</span>
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 max-w-2xl text-base md:text-lg text-slate-300 leading-relaxed" data-testid="about-intro-body">
            Expect clear recommendations, transparent pricing and personal service. Visit our studio or choose mobile detailing at your location—with a complimentary ride home and return pickup available for shop appointments within Vernon and Coldstream.
          </p>
        </Reveal>
        <div className="mt-10 flex flex-wrap gap-3">
          {PILLARS.map((p, i) => (
            <motion.span key={p} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.7, ease: EASE, delay: 0.2 + i * 0.08 }}
              className="inline-flex items-center gap-3 h-11 px-5 border border-white/15 text-sm">
              <span className="h-1.5 w-1.5 rotate-45 bg-[#1bb4f2]" />{p}
            </motion.span>
          ))}
        </div>
      </div>
    </div>
  </section>
);
